import React from 'react';

import { AuthProvider } from '../providers/AuthContext';
import { CommunicationCenterProvider } from '../providers/CommunicationCenterContext';
import { DealerProvider } from '../providers/DealerContext';
import { ToastProvider } from '../../shared/context/ToastContext';
import { UserProvider } from '../providers/UserContext';
import { VehicleProvider } from '../providers/VehicleContext';
import { DisclaimerProvider } from '../../shared/context/DisclaimerContext';

export const ProvidersWrapper = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  return (
    <ToastProvider>
      <AuthProvider>
        <UserProvider>
          <CommunicationCenterProvider>
          <VehicleProvider>
            <DealerProvider>
              <DisclaimerProvider>{children}</DisclaimerProvider>
            </DealerProvider>
          </VehicleProvider>
          </CommunicationCenterProvider>
        </UserProvider>
      </AuthProvider>
    </ToastProvider>
  );
};
